var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartupProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 107,
    viewBox: "0 0 158 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.638143 50C0.638143 22.7382 22.7382 0.638143 50 0.638143H108C135.262 0.638143 157.362 22.7382 157.362 50V106.362H50C22.7382 106.362 0.638143 84.2618 0.638143 57V50Z",
    fill: "#0047AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5059 58.4684C66.6996 58.6621 67.0184 58.6621 67.2121 58.4684L73.5746 52.1059L78.9559 57.4934C79.1496 57.6871 79.4684 57.6871 79.6621 57.4934L93.8059 43.3371C93.9996 43.1434 93.9996 42.8246 93.8059 42.6309L91.5059 40.3309C91.3121 40.1371 90.9934 40.1371 90.7996 40.3309L79.3121 51.8309L73.9309 46.4434C73.7371 46.2496 73.4184 46.2496 73.2246 46.4434L64.2059 55.4621C64.0121 55.6559 64.0121 55.9746 64.2059 56.1684L66.5059 58.4684Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 31.5H81.25V27.5C81.25 27.225 81.025 27 80.75 27H77.25C76.975 27 76.75 27.225 76.75 27.5V31.5H54.5C53.3937 31.5 52.5 32.3938 52.5 33.5V66C52.5 67.1063 53.3937 68 54.5 68H76.775V70L66.475 76.7562C66.2438 76.9062 66.1812 77.2125 66.3312 77.4437L68.225 80.3937V80.4C68.375 80.6313 68.6875 80.6938 68.9188 80.5438L79 73.9313L89.0812 80.5438C89.3125 80.6938 89.625 80.6313 89.775 80.4V80.3937L91.6688 77.4437C91.8188 77.2125 91.75 76.9062 91.525 76.7562L81.25 70.0187V68H103.5C104.606 68 105.5 67.1063 105.5 66V33.5C105.5 32.3938 104.606 31.5 103.5 31.5ZM101 63.5H57V36H101V63.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.638143 50C0.638143 22.7382 22.7382 0.638143 50 0.638143H108C135.262 0.638143 157.362 22.7382 157.362 50V106.362H50C22.7382 106.362 0.638143 84.2618 0.638143 57V50Z",
    stroke: "#0047AF",
    strokeWidth: 1.27629
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupProjects);
export default __webpack_public_path__ + "static/media/StartupProjects.01bcb567db0e91b527b35c7492edb4ed.svg";
export { ForwardRef as ReactComponent };